const VALID_VERSIONS = new Set(["v1", "v2"]);
const DEFAULT_STORAGE_PREFIX = "akongo:welfare-interface";
export const readSavedVersionPreference = (storage, userId, prefix = DEFAULT_STORAGE_PREFIX) => {
  try {
    const value = storage?.getItem?.(`${prefix}:${userId}`);
    return VALID_VERSIONS.has(value) ? value : null;
  } catch (_) {
    return null;
  }
};

export const createVersionPreferences = (
  storage,
  prefix = DEFAULT_STORAGE_PREFIX
) => ({
  read(userId) {
    return readSavedVersionPreference(storage, userId, prefix) || "v1";
  },
  write(userId, version) {
    if (!VALID_VERSIONS.has(version)) {
      throw new TypeError("version must be v1 or v2");
    }
    if (!storage || typeof storage.setItem !== "function") return;
    storage.setItem(`${prefix}:${userId}`, version);
  },
});

